module.exports = __webpack_public_path__ + "img/logo.8f40d78b.png";